import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeeeLandingPageRoutingModule } from './weee-landing-page-routing.module';
import { WeeeFeedbackComponent } from './components/weee-feedback/weee-feedback.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { WEEE_FEEDBACK_FEATURE_NAME } from '~shared/modules/weee-landing-page/store/feature-name';
import { MmButtonModule, MmIconModule } from '@metromarkets/components';
import * as fromWeeeFeedbackStore from  '~shared/modules/weee-landing-page/store';
import { TranslateModule } from '@ngx-translate/core';
import { PageLoadingModule } from '~shared/components/page-loading/page-loading.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [WeeeFeedbackComponent],
  imports: [
    CommonModule,
    WeeeLandingPageRoutingModule,
    StoreModule.forFeature(WEEE_FEEDBACK_FEATURE_NAME, fromWeeeFeedbackStore.weeeFeedbackReducer),
    EffectsModule.forFeature([fromWeeeFeedbackStore.WeeeFeedabackEffects]),
    MmIconModule,
    TranslateModule,
    PageLoadingModule,
    MmButtonModule,
    FlexLayoutModule
  ]
})
export class WeeeLandingPageModule { }
